"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pivotTableConfigFromInsight = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_model_1 = require("@gooddata/sdk-model");
var PluggablePivotTable_1 = require("./PluggablePivotTable");
var propertiesHelper_1 = require("../../../utils/propertiesHelper");
function pivotTableConfigFromInsight(insight, ctx) {
    var _a, _b;
    var baseConfig = (ctx === null || ctx === void 0 ? void 0 : ctx.settings) && ctx.backend
        ? PluggablePivotTable_1.createPivotTableConfig({ separators: (_a = ctx === null || ctx === void 0 ? void 0 : ctx.settings) === null || _a === void 0 ? void 0 : _a.separators }, "none", ctx.settings, ctx.backend.capabilities, (_b = propertiesHelper_1.getColumnWidthsFromProperties(sdk_model_1.insightProperties(insight))) !== null && _b !== void 0 ? _b : [])
        : {};
    var columnSizingProp = !isEmpty_1.default(baseConfig.columnSizing)
        ? { columnSizing: baseConfig.columnSizing }
        : {};
    var menuProp = !isEmpty_1.default(baseConfig.menu) ? { menu: baseConfig.menu } : {};
    var separatorsProp = !isEmpty_1.default(baseConfig.separators) ? { separators: baseConfig.separators } : {};
    return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, columnSizingProp), menuProp), separatorsProp);
}
exports.pivotTableConfigFromInsight = pivotTableConfigFromInsight;
//# sourceMappingURL=pivotTableConfigFromInsight.js.map